// Application Facade para React

// contexto/CajaContext.js
import { createContext, useContext, useState , useCallback } from "react";

import { abrirCajaUseCase } from "../../../core/caja/application/abrirCaja.usecase.js";
import { cerrarCajaUseCase } from "../../../core/caja/application/cerrarCaja.usecase.js";
import { obtenerSesionAbiertaUseCase } from "../../../core/caja/application/obtenerSesionAbierta.usecase.js";
import { obtenerSesionAbiertaPorDiaUseCase } from "../../../core/caja/application/obtenerSesionAbiertaPorDia.usecase.js";
import { listarCajasSesionUseCase } from "../../../core/caja/application/listarSesiones.usecase.js";

const CajaSesionContext = createContext(null);

export function CajaSesionProvider({ children }) {
  const [sesionActual, setSesionActual] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // 🔓 Abrir caja
  const abrirCaja = async (data) => {
    setLoading(true);
    setError(null);

    try {
      const sesion = await abrirCajaUseCase(data);
      setSesionActual(sesion);
      return sesion;
    } catch (e) {
      setError(e.message);
      throw e;
    } finally {
      setLoading(false);
    }
  };

  // 🔒 Cerrar caja
  const cerrarCaja = async (data) => {
    setLoading(true);
    setError(null);

    try {
      const sesion = await cerrarCajaUseCase(data);
      setSesionActual(null);
      return sesion;
    } catch (e) {
      setError(e.message);
      throw e;
    } finally {
      setLoading(false);
    }
  };

  // 🔄 Rehidratar sesión (refresh / reload app)
  const cargarSesionAbierta = async (punto) => {
    setLoading(true);
    setError(null);

    try {
      const sesion = await obtenerSesionAbiertaUseCase({ punto });
      setSesionActual(sesion);
      return sesion;
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };


const listarSesiones = useCallback(async (filtros) => {
  setLoading(true);
  try {
    const result = await listarCajasSesionUseCase(filtros);
    console.log("[listarSesiones] filtros:", filtros);
    console.log("[listarSesiones] resultado:", result);
    return result;
  } finally {
    setLoading(false);
  }
}, []);

const obtenerSesionAbiertaPorDia = async ({ punto, fecha }) => {
  setLoading(true);
  setError(null);

  try {
    const sesion = await obtenerSesionAbiertaPorDiaUseCase({ punto, fecha });
    return sesion; // puede ser null si no hay sesión hoy
  } catch (e) {
    setError(e.message);
    throw e;
  } finally {
    setLoading(false);
  }
};
  return (
    <CajaSesionContext.Provider
      value={{
        sesionActual,
        loading,
        error,
        abrirCaja,
        cerrarCaja,
        cargarSesionAbierta,
        listarSesiones,
        obtenerSesionAbiertaPorDia,
      }}
    >
      {children}
    </CajaSesionContext.Provider>
  );
}

export function useCaja() {
  const context = useContext(CajaSesionContext);
  if (!context) {
    throw new Error(" [useCaja]  debe usarse dentro de CajaProvider");
  }
  return context;
}